import { isStag } from './isStag';

export const getWebBaseURL = async () => {
  if (await isStag()) {
    if (document.referrer.length === 0) {
      return 'https://m-stag.a-bly.com';
    }
    const lastChar = document.referrer.charAt(document.referrer.length - 1);
    if (lastChar === '/') {
      return document.referrer.slice(0, -1);
    }
    return document.referrer;
  }
  return 'https://m.a-bly.com';
};
